import React from "react";
import {
    Navigate,
} from "react-router-dom";
import ContainerRedirect from "../../../../../pages/lib/page-redirect";

const ContainerCheckPointListComponent = React.lazy(() => import("../../../../../components/malimax-three/components/list/page"));
const ContainerCheckPointAddComponent = React.lazy(() => import("../../../../../components/malimax-three/components/add/page"));


export const malimaxThreeRoute = [
    {
        path: 'list',
        element: <ContainerCheckPointListComponent />,
    },
    {
        path: 'add',
        element: <ContainerCheckPointAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/form-process/three/add" />
    },
    {
        path: 'edit/:id',
        element: <ContainerCheckPointAddComponent />
    },
    {
        path: "",
        element: <ContainerRedirect elroute="/form-process/three"/>
      },
];